export const matchIcon = (fileName: string) => {
  const extension = fileName.split('.').reverse()[0];
  return `/icons/${extension}.svg`;
};
